import { render, staticRenderFns } from "./OrganizationSettingsAdmins.vue?vue&type=template&id=f124a426&scoped=true"
import script from "./OrganizationSettingsAdmins.vue?vue&type=script&lang=ts&setup=true"
export * from "./OrganizationSettingsAdmins.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./OrganizationSettingsAdmins.vue?vue&type=style&index=0&id=f124a426&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f124a426",
  null
  
)

export default component.exports